/**
 * Standalone Team Chat Redirect Page
 * Path: /teams/[teamId]/chat - redirects to new chat
 *
 * This is the main entry point for team chat interface.
 * Redirects to the new chat page.
 */

import { Navigate, useParams } from 'react-router-dom'

export function StandaloneTeamChatRedirectPage() {
  const { teamId } = useParams<{ teamId: string }>()

  return <Navigate to={`/teams/${teamId}/chat/new`} replace />
}
